import { Button, ButtonSize, ButtonType } from '@/common/button';
import { Modal } from '@/common/modal';
import React, { useRef, useEffect, type FC } from 'react';

interface ImageDownloadModalProps {
    src: string;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

export const ImageDownloadModal: FC<ImageDownloadModalProps> = ({ isOpen, setIsOpen, src }) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const downloadLinkRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, setIsOpen]);

    const handleDownload = () => {
        downloadLinkRef.current?.click();
        setIsOpen(false);
    };

    return (
        <Modal isOpen={isOpen}>
            <div
                ref={modalRef}
                className="flex flex-col justify-between absolute min-w-96 w-[50vw] h-[80vh] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out p-4"
            >
                <div className="flex flex-row justify-end items-center">
                    <Button
                        title="Download"
                        buttonType={ButtonType.PRIMARY}
                        buttonSize={ButtonSize.LARGE}
                        onClick={handleDownload}
                    />
                    <a ref={downloadLinkRef} href={src} download={true} className="hidden">
                        Download Image
                    </a>
                </div>
                <div className="w-full chess h-[68vh] p-2">
                    <img src={src} alt="Asset" className="rounded object-contain h-full w-full aspect-square" />
                </div>
            </div>
        </Modal>
    );
};
